import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import NewsLetterForm from "../CarrierLanding/LatestNews/LatestNews"
import FeaturedNews from "./NewsListings/FeaturedNews"
import NewsList from "./NewsListings/NewsList"
import "./NewsLanding.scss"

const NewsLanding = (props) => {  
    return(
        <React.Fragment>
            <section className="news-landing-wrapper">
                <Container>
                    <Row>
                        <Col>
                            <FeaturedNews categorySlug={props?.categorySlug} /> 
                            <NewsList categorySlug={props?.categorySlug} />
                        </Col>
                    </Row>
                    <Row>
                        <NewsLetterForm />
                    </Row>                   
                </Container>
            </section>
        </React.Fragment>
    )
};
export default NewsLanding;
